import React from "react";
import { NumericFormat } from "react-number-format";

export default function CurrencyInput({ value, onChange, locale = "en-US", currency = "USD", ...props }) {
  const formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
  });

  return (
    <NumericFormat
      value={value}
      onValueChange={(values) => onChange(values.floatValue ?? 0)}
      thousandSeparator={true}
      decimalScale={2}
      fixedDecimalScale
      allowNegative={false}
      prefix={formatter.formatToParts(0).find(part => part.type === "currency")?.value || ""}
      {...props}
    />
  );
}
